export function noJitter(delay) {
    return delay;
}
